import Article from "./Article"
import HorizontalArticle from "./HorizontalArticle"
import CaseStudy from "./CaseStudy"

export default {
  Article,
  CaseStudy,
  HorizontalArticle,
}
